import LogicaAPI from "./logicaapi";

class Subscribe extends LogicaAPI {
  async subscribe(courseId, paymentInstrumentId, voucherCode) {
    const params = {
      course_id: courseId,
      payment_instrument_id: paymentInstrumentId,
      with_course: true,
      with_course_pricing: true,
    };

    if (voucherCode) {
      params.voucher_code = voucherCode;
    }

    console.log("subscribe", params);
    const res = this.post("/api/v1/subscriptions/subscribe", { body: params });
    return res;
  }

  async subscription() {
    const params = {
      with_course: true,
      with_payment_instrument: true,
      with_course_pricing: true,
      status_scope: "active",
      with_entitlements: true,
    };
    return this.get("/api/v1/subscriptions", { params });
  }

  async subscriptionStatus(courseId) {
    const params = {
      course_id: courseId,
    };
    return this.get("/api/v1/subscriptions/status", { params });
  }

  async subscriptionOne(subscriptionId) {
    const params = {
      with_course: true,
      with_payment_instrument: true,
      with_course_pricing: true,
      with_entitlements: true,
    };
    return this.get(`/api/v1/subscriptions/${subscriptionId}`, { params });
  }

  async subscriptionCancel(id) {
    const params = {
      course_id: id,
    };
    console.log("subscriptionCancel", params);
    const res = this.post("/api/v1/subscriptions/cancel", { body: params });
    return res;
  }

  async subscriptionCheckCancelable(subscriptionId) {
    const params = {
      subscription_id: subscriptionId,
    };
    return this.post("/api/v1/subscriptions/check_cancelable", {
      body: params,
    });
  }

  async subscriptionChangePayment(args) {
    const params = {
      payment_instrument_id: args.paymentInstrumentId,
    };
    return this.post(`/api/v1/subscriptions/${args.subscriptionId}/edit`, {
      body: params,
    });
  }

  async formQuestions(args) {
    const res = this.get(`/api/v1/form/question/${args.id}`);
    return res;
  }

  async formQuestionAnswer(id, values) {
    return this.post(`/api/v1/form/question/${id}/answers`, {
      body: { values },
    });
  }

  /**
   * estimate.
   *
   * @param {Integer} courseId
   * @param {Integer} paymentMethodId
   * @param {String} couponCode
   */
  async estimate(courseId, paymentMethodId, couponCode) {
    const params = {
      course_id: courseId,
    };
    if (paymentMethodId) {
      params.paymentMethodId = paymentMethodId;
    }
    if (couponCode) {
      params.use_coupon = true;
      params.coupon_code = couponCode;
    }
    return this.get(`/api/v1/subscribe_process/estimate`, { params });
  }

  /**
   * applyCoupon.
   *
   * @param {Integer} courseId
   * @param {Integer} paymentMethodId
   * @param {String} campaignCode
   */
  async applyCampaign(courseId, campaignCode) {
    const params = {
      course_id: courseId,
      coupon_code: campaignCode,
    };
    return this.get(`/api/v1/subscribe_process/apply_coupon`, { params });
  }

  /**
   * subscriptionFromCourseId.
   *
   * @param {Integer} courseId
   */
  async subscriptionFromCourseId(courseId) {
    const params = {
      with_subscription: true,
      course_id: courseId,
    };
    const res = await this.get("/api/v1/users/subscription_status_histories", {
      params,
    });
    return res?.subscriptions?.[0]?.subscription;
  }
}
export default Subscribe;
